import Pdf from './src/Pdf.vue'

export default Pdf


// WEBPACK FOOTER //
// ./~/iexplore/components/pdf/index.js